<app-column-header [headerData]="headerData" (topbtnaction)="onSubmit()"></app-column-header>
<form [formGroup]="createPageForm" (ngSubmit)="onSubmit()">
    <div class="commonBlock">
        <div class="row">
            <div class="col-1-of-3">
                <div class="formGroup">
                    <label class="control-label">Page Name</label>
                    <input type="text" formControlName="pageName" class="form-control inputText" maxlength="30"
                        placeholder="Enter Page Name">
                </div>
                <div class="formGroup ">
                    <label class="control-label">Page Description</label>
                    <input type="text" formControlName="pageDescription" class="form-control inputText"
                        placeholder="Enter Page Description">
                </div>
                <div class="formGroup ">
                    <label class="control-label">Icon</label>
                    <ng-select class="form-control" [items]="iconListOption" formControlName="pageIcon"
                        placeholder="Icon Option" appendTo="body" bindLabel="name"
                        bindValue="id"></ng-select>
                </div>
                <div class="formGroup ">
                    <div class="radioGroup">
                        <svg class="icon iconWH">
                            <use [attr.xlink:href]="srcPath.menuIconPath + createPageForm.value.pageIcon"></use>
                        </svg>
                    </div>
                </div>
                <div class="formGroup ">
                    <label class="control-label">Background color</label>
                    <input type="color" class="form-control inputText bgtxtHeight" placeholder="Enter Background color"
                        formControlName="pageBgColor">
                </div>
                <div class="formGroup ">
                    <label class="control-label">Icon style</label>
                    <ng-select class="form-control" [items]="iconStyleOption" formControlName="iconStyle"
                        placeholder="Icon Style" bindLabel="name" bindValue="id"></ng-select>

                </div>
                <div class="formGroup ">
                    <label class="control-label">Popup Width Class</label>
                    <ng-select class="form-control" [items]="popupWidthClassOption" formControlName="popupWidthClass" placeholder="Class"
                     bindLabel="name" bindValue="id"></ng-select>
          
                  </div>
                <div class="radioGroup ">
                    <input name="linkPage" id="linkPage" class="checkBox" type="checkbox" formControlName="isLinkPage" />
                    <label class="control-label" for="linkPage"><span></span>Link Page
                    </label>
                </div>
                <div class="formGroup" *ngIf="createPageForm.value.isLinkPage && appPageList.length>0">
                    <ng-select class="form-control" formControlName="linkPageId" [items]="appPageList"
                        placeholder="Select page" bindLabel="pageName" bindValue="pageId"></ng-select>

                </div>
                <div class="radioGroup">
                    <input name="showstatic" id="staticdata" class="checkBox" type="checkbox" formControlName="isShowStaticData" />
                    <label class="control-label" for="staticdata"><span></span>Need to Show Static Data
                    </label>
                </div>
                <div class="formGroup" *ngIf="createPageForm.value.isShowStaticData && appPageList.length>0">
                    <ng-select class="form-control" formControlName="staticDataPageId" [items]="appPageList"
                        placeholder="Select page" bindLabel="pageName" bindValue="pageId"></ng-select>
                </div>
               
            </div>
        </div>
    </div>
</form>